import React from "react";
import { Route, Routes } from "react-router-dom";

import {
  useRetrieveCurrentPlanzone,
  useRetrieveDocuments,
  useRetrieveDocumentTemplatesFolder,
} from "@planzone/view-models";
import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { ProfileNavigation } from "@common/profileNavigation";
import { DragAndDrop } from "@common/dragAndDrop";
import { SideBar } from "./sideBar";
import { ReportsPage } from "./reportsPage";
import { DocumentsPage as SubDocumentsPage } from "./documentsPage";
import { Props } from "./types";
import styles from "./styles.scss";

function DocumentsPage(_: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    folder,
    retrieveDocuments,
  } = useRetrieveDocuments(planzone.uuid, "planzone");
  const { retrieveDocumentTemplatesFolder } =
    useRetrieveDocumentTemplatesFolder();
  const header = () => (
    <div className={styles.header}>
      <div className={styles.profileNavigation}>
        <AssistantShortcut />
        <Notifications />
        <ProfileNavigation />
      </div>
    </div>
  );
  const sideBar = () => <SideBar planzone={planzone} documents={folder} />;

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveDocuments({ namespace: planzone.uuid, type: "planzone" });
  }, [planzone.uuid]);

  React.useEffect(() => {
    isRequestSuccess &&
      retrieveDocumentTemplatesFolder({ planzone: planzone.uuid });
  }, [isRequestSuccess]);

  return (
    <DragAndDrop>
      <div className={styles.documentsPage}>
        <Routes>
          <Route
            path="reports"
            element={<ReportsPage header={header()} sideBar={sideBar()} />}
          />
          <Route
            path="folders/:folderId"
            element={<SubDocumentsPage header={header()} sideBar={sideBar()} />}
          />
          <Route
            path="*"
            element={<SubDocumentsPage header={header()} sideBar={sideBar()} />}
          />
        </Routes>
      </div>
    </DragAndDrop>
  );
}

export { DocumentsPage };
